/**
 * Vendor API Module
 * Handles vendor entity management and menu operations
 */

import { api } from './client'

export const vendorAPI = {
  // Vendor status + entities
  getStatus: () => api.get('/vendor/status', { silentError: true }),
  getEntities: () => api.get('/vendor/entities', { silentError: true }),

  // Menu / offerings (public reads)
  getMenu: (entityId) => api.get(`/entities/${entityId}/menu`, { silentError: true }),
  getOfferings: (entityId) => api.get(`/entities/${entityId}/offerings`, { silentError: true }),
  getOfficialOfferings: (entityId) => api.get(`/entities/${entityId}/official-menu`, { silentError: true }),

  // Submit a crowdsourced offering (auth required)
  submitOffering: (entityId, data) => api.post(`/entities/${entityId}/offerings`, data),

  // Admin: add official menu item
  addOfficialOffering: (entityId, data) => api.post(`/admin/entities/${entityId}/offerings`, data),

  // Vendor offering management (vendor-scoped, requires vendor middleware)
  getVendorOfferings: (entityId) => api.get(`/vendor/entities/${entityId}/offerings`),
  createVendorOffering: (entityId, data) => api.post(`/vendor/entities/${entityId}/offerings`, data),
  updateOffering: (entityId, offeringId, data) => api.put(`/vendor/entities/${entityId}/offerings/${offeringId}`, data),
  deleteOffering: (entityId, offeringId) => api.delete(`/vendor/entities/${entityId}/offerings/${offeringId}`),

  // Admin: invite management (entity-linked)
  getInvites: (params) => api.get('/admin/invites', { params }),
  sendInvite: (data) => api.post('/admin/invites', data),
  updateInvite: (id, data) => api.put(`/admin/invites/${id}`, data),
  revokeInvite: (id) => api.delete(`/admin/invites/${id}`),

  // Self-service stewardship release
  releaseStewardship: (entityId) => api.delete(`/vendor/entities/${entityId}/stewardship`),

  // Admin: direct vendor assignment (no email required)
  getEntityVendors: (entityId) => api.get(`/admin/entities/${entityId}/vendors`),
  assignVendor: (entityId, userId) => api.post(`/admin/entities/${entityId}/vendors`, { userId }),
  removeVendor: (entityId, userId) => api.delete(`/admin/entities/${entityId}/vendors/${userId}`),

  // Schedule (public read, vendor write)
  getEntitySchedule: (entityId) => api.get(`/entities/${entityId}/schedule`, { silentError: true }),
  createScheduleSlot: (entityId, data) => api.post(`/vendor/entities/${entityId}/schedule`, data),
  updateScheduleSlot: (entityId, slotId, data) => api.put(`/vendor/entities/${entityId}/schedule/${slotId}`, data),
  deleteScheduleSlot: (entityId, slotId) => api.delete(`/vendor/entities/${entityId}/schedule/${slotId}`),
  createEntityEvent: (entityId, data) => api.post(`/vendor/entities/${entityId}/events`, data),
  updateEntityEvent: (entityId, eventId, data) => api.put(`/vendor/entities/${entityId}/events/${eventId}`, data),
  deleteEntityEvent: (entityId, eventId) => api.delete(`/vendor/entities/${entityId}/events/${eventId}`),
}

// Vendor broadcast API (separate export so VendorBroadcastModal can import directly)
export const vendorBroadcastAPI = {
  send: (entityId, title, message) =>
    api.post(`/vendor/entities/${entityId}/broadcast`, { title, message }),
}
